// Single source for "which calendar cells open a result box". Shared by CalendarGrid
// (cell click) and the Reports list view (task-name link, REBUILD-605) so both surfaces
// open the same box for the same result.

interface ClickableCellShape {
  state: string
  meta: {
    instrumentTaskLogId: number | null
    requiredComplianceId: number | null
  }
}

export const LOG_CLICKABLE_STATES: ReadonlySet<string> = new Set(['success', 'no_testing'])

// failure is always in MISSED_CLICKABLE_STATES; the click handler branches on instrumentTaskLogId
export const MISSED_CLICKABLE_STATES: ReadonlySet<string> = new Set([
  'failure',
  'override',
  'confirmed',
])

// Executed QC-fail (RC-linked or log-only) carries instrumentTaskLogId → Log Details
// (day-occurrences drops qc_failed orphans — AC5 Failure modal separation).
// True miss carries requiredComplianceId and no log id → day-occurrences.
export const isExecutedFailureCell = (cell: ClickableCellShape): boolean =>
  cell.state === 'failure' && cell.meta.instrumentTaskLogId != null

export const isLogClickableCell = (cell: ClickableCellShape): boolean =>
  (LOG_CLICKABLE_STATES.has(cell.state) && cell.meta.instrumentTaskLogId != null) ||
  isExecutedFailureCell(cell)

export const isMissedClickableCell = (cell: ClickableCellShape): boolean =>
  MISSED_CLICKABLE_STATES.has(cell.state) &&
  cell.meta.requiredComplianceId != null &&
  !isExecutedFailureCell(cell)
